/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import {Address4, Address6} from "ip-address";

export function getIpObject(ip){
    let ipv4 = new Address4(ip);
    if(ipv4.isValid()){
        return ipv4
    }
    let ipv6 = new Address6(ip);
    if(ipv6.isValid()){
        return ipv6
    }
    return null;
}
